export default __webpack_public_path__ + "static/media/chubasquero-mujer.80e86cbf.png";